define('presentation/settings/billing/plans/validators/removePlanValidator',['presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule',
], function() {
    return function() {
        const self = this;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        let _commonValidator = null;
        let _facade = null;
        let _viewModel = null;

        self.registerViewModel = (viewModel, facade) => {
            _facade = facade;
            _viewModel = viewModel;
            _commonValidator = new CommonValidatorConstructor(viewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("removePlanFeedback")
                .addValidationI18n(_commonValidator.isStringWithValue, 'removePlan:pleaseSelectReason');
            validationRules.field("removePlanOtherFeedback")
                .addValidationI18n(_validateOtherFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("lacksFeaturesFeedback")
                .addValidationI18n(_validateLacksFeaturesFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("billingIssueFeedback")
                .addValidationI18n(_validateBillingIssueFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("technicalIssueFeedback")
                .addValidationI18n(_validateTechnicalIssueFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("poorCustomerServiceFeedback")
                .addValidationI18n(_validatePoorCustomerServiceFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("tooDifficultToUseFeedback")
                .addValidationI18n(_validateToDifficultToUseFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("tooExpensiveFeedback")
                .addValidationI18n(_validateTooExpensiveReason, 'removePlan:pleaseMakeSelection');
            validationRules.field("tooExpensiveOtherFeedback")
                .addValidationI18n(_validateTooExpensiveOtherFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("noLongerNeededFeedback")
                .addValidationI18n(_validateNoLongerNeededReason, 'removePlan:pleaseMakeSelection');
            validationRules.field("noLongerNeededOtherFeedback")
                .addValidationI18n(_validateNoLongerNeededOtherFeedback, 'removePlan:pleaseProvideResponse');
            validationRules.field("areYouSwitchingServices")
                .addValidationI18n(_commonValidator.isStringWithValue, 'removePlan:pleaseMakeSelection');
            validationRules.field("whichService")
                .addValidationI18n(_validateWhichService, 'removePlan:pleaseSpecifyWhichService');
            validationRules.field("howLikelyAreYouToRecommend")
                .addValidationI18n(_commonValidator.isNumber, 'removePlan:pleaseMakeSelection');

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        const _validateOtherFeedback = (otherFeedback) => {
            if (_viewModel.showOtherFeedbackForm()) {
                return _commonValidator.isStringWithValue(otherFeedback);
            }
            return true;
        };

        const _validateLacksFeaturesFeedback = (lacksFeaturesFeedback) => {
            if (_viewModel.showLacksFeaturesForm()) {
                return _commonValidator.isStringWithValue(lacksFeaturesFeedback);
            }
            return true;
        };

        const _validateToDifficultToUseFeedback = (tooDifficultToUseFeedback) => {
            if (_viewModel.showTooDifficultToUseForm()) {
                return _commonValidator.isStringWithValue(tooDifficultToUseFeedback);
            }
            return true;
        };

        const _validateBillingIssueFeedback = (billingIssueFeedback) => {
            if (_viewModel.showBillingIssueForm()) {
                return _commonValidator.isStringWithValue(billingIssueFeedback);
            }
            return true;
        };

        const _validateTechnicalIssueFeedback = (technicalIssueFeedback) => {
            if (_viewModel.showTechnicalIssueForm()) {
                return _commonValidator.isStringWithValue(technicalIssueFeedback);
            }
            return true;
        };

        const _validatePoorCustomerServiceFeedback = (poorCustomerServiceFeedback) => {
            if (_viewModel.showPoorCustomerServiceForm()) {
                return _commonValidator.isStringWithValue(poorCustomerServiceFeedback);
            }
            return true;
        };

        const _validateTooExpensiveReason = (tooExpensiveFeedback) => {
            if (_viewModel.showTooExpensiveFeedbackForm()) {
                return _commonValidator.isStringWithValue(tooExpensiveFeedback);
            }
            return true;
        };

        const _validateTooExpensiveOtherFeedback = (tooExpensiveOtherFeedback) => {
            if (_viewModel.showTooExpensiveFeedbackForm() && _viewModel.showTooExpensiveOtherFeedback()) {
                return _commonValidator.isStringWithValue(tooExpensiveOtherFeedback);
            }
            return true;
        };

        const _validateNoLongerNeededReason = (noLongerNeededFeedback) => {
            if (_viewModel.showNoLongerNeededFeedbackForm()) {
                return _commonValidator.isStringWithValue(noLongerNeededFeedback);
            }
            return true;
        };

        const _validateNoLongerNeededOtherFeedback = (noLongerNeededOtherFeedback) => {
            if (_viewModel.showNoLongerNeededFeedbackForm() && _viewModel.showNoLongerNeededOtherFeedback()) {
                return _commonValidator.isStringWithValue(noLongerNeededOtherFeedback);
            }
            return true;
        };

        const _validateWhichService = (whichService) => {
            if (_viewModel.showWhichService()) {
                return _commonValidator.isStringWithValue(whichService);
            }
            return true;
        };

        self.validate = () => _commonValidator.validate();
    };
});
